import styled from 'styled-components';
import { COLORS } from '../../../../constants/radar';

export const TreeContainer = styled.div`
  width: 100%;
  display: flex;
  position: relative;

  > svg {
    width: 100%;
    height: 100%;
    overflow: visible;
    user-select: none;
    -webkit-user-select: none;
  }

  .dimmed {
    visibility: hidden !important;
    pointer-events: none !important;
  }

  .action-buttons {
    pointer-events: all;
     
    circle {
      transition: filter 0.2s ease-in-out;
       
      &:hover {
        filter: brightness(0.9);
      }
    }
     
    text {
      pointer-events: none;
      font-family: Arial, sans-serif;
    }
  }
`;

export const TreeControls = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ControlButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: white;
  border: 1px solid ${COLORS.BACKGROUND_DARK};
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  color: ${COLORS.PRIMARY};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    border-color: ${COLORS.PRIMARY};
  }

  span {
    font-weight: 500;
  }

  svg {
    width: 10px;
    height: 10px;
    color: ${COLORS.PRIMARY};
  }
`;

export const Legend = styled.div`
  background-color: white;
  border: 1px solid ${COLORS.BACKGROUND_DARK};
  border-radius: 4px;
  padding: 8px;
  font-size: 11px;
  color: ${COLORS.SECONDARY};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const LegendDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.color};
`;
